// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__q1Aro","tab":"Tabs_tab__ZpXU8","isActiveTab":"Tabs_isActiveTab__WZ1yw"};